<template>
  <div class="hvh-flex">
    <span class="add-group hvh-flex align-center" @click="$emit('click', $event)">
      <span class="font-sm">{{ label }}</span>
      <v-icon dense>mdi-plus</v-icon>
    </span>
    <v-tooltip right>
      <template v-slot:activator="{ on }">
        <v-icon class="clickable ml-2" small v-on="on">mdi-help-circle-outline</v-icon>
      </template>
      <span>{{ help }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  props: ['label', 'help']
}
</script>

<style lang="scss" scoped>
.add-group {
  border-radius: 13px;
  background-color: #ffffff;
  box-shadow: 0 1px 4px 1px rgba(6, 10, 36, 0.1), 0 5px 10px 0 rgba(6, 10, 36, 0.08);
  padding: 0 2px 0 8px;
  cursor: pointer;
}
</style>